// Basic
import { useState } from 'react';
// Store & actions
import useSessionStore from '@/app/store/session';
import useCustomPayStore from '@/app/store/customPay';
// Components
import Page from '@/common-utils/components/structure/page/Page';
import OrganizationsTable from '@/app/modules/organizations/components/tables/OrganizationsTable';
import PageActions from '@/common-utils/components/renders/pageActions/PageActions';
import ModalAddOrganization from '@/app/modules/organizations/components/modals/addOrganization/ModalAddOrganization';
// Common
import ICONS from '@/common-utils/enums/icons';
import RouteUrls from '../enums/RouteUrls';
import hasRequiredPermissions from '@/common-utils/functions/hasRequiredPermissions';
import Permissions from '@/app/permissions/Permissions';
import useRootOrganizationStore from '@/app/store/rootOrganization';
import { nsOrganization } from '@/app/i18n/namespaces';
import setFiltersEventName from '@/common-utils/components/renders/dataTable/utils/setFiltersEventName';
/**
 * @returns {JSX} Organizations
 */
function Organizations() {

    // State
    const [showModalAddOrganization, setShowModalAddOrganization] = useState(false);

    // Store
    const { permissions: userPermissions } = useSessionStore(s => s.session);
    const { uuid: organizationId } = useRootOrganizationStore(s => s.rootOrganization);
    const isCustomPay = useCustomPayStore((s) => s.isCustomPay);

    return (
        <Page>
            <Page.Header
                route={RouteUrls.ORGANIZATIONS}
                routeBase={RouteUrls.ORGANIZATIONS}
            />
            <Page.Body data-cy='page-organizations'>

                <OrganizationsTable
                    filtersEventName={setFiltersEventName('organizations')}
                    pageActions={
                        <PageActions actions={[{
                            icon: ICONS.ADD,
                            entity: 'actions.page.add_organization',
                            namespace: nsOrganization,
                            onClick: () => setShowModalAddOrganization(true),
                            visible: !isCustomPay,
                            disabled: !hasRequiredPermissions({
                                permissions: userPermissions,
                                requiredPermissions: [
                                    Permissions.ORGANIZATION_CREATE_CLIENT_ORGANIZATION.name
                                ]
                            }),
                            tooltipForbidden: 'title.permissions.access_denied'
                        }]}
                            retractable
                        />
                    } />

            </Page.Body>
            {
                showModalAddOrganization &&
                <ModalAddOrganization
                    isOpen={showModalAddOrganization}
                    setIsOpen={setShowModalAddOrganization}
                    currentOrganizationId={organizationId}
                />
            }
        </Page>
    );
}

export default Organizations;